import { render } from "./PanelBundleMetadata.vue?vue&type=template&id=6c8323ba&scoped=true&ts=true"
import script from "./PanelBundleMetadata.vue?vue&type=script&lang=ts"
export * from "./PanelBundleMetadata.vue?vue&type=script&lang=ts"

import "./PanelBundleMetadata.vue?vue&type=style&index=0&id=6c8323ba&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8323ba"]])

export default __exports__